import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessFinancialsRoute extends Route {
  @service organisation;

  model() {
    return this.organisation.organisation;
  }
}

export default instrumentRoutePerformance(BusinessFinancialsRoute);
